import axios from "axios";
import { PORTAL_API } from "@/lib/portalApi";

const GUEST_KEY = "hdb_planner_guest";

export const guestId = () => {
    let g = localStorage.getItem(GUEST_KEY);
    if (!g) {
        g = crypto.randomUUID ? crypto.randomUUID()
            : "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
                const r = (Math.random() * 16) | 0;
                return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
            });
        localStorage.setItem(GUEST_KEY, g);
    }
    return g;
};

const plannerApi = axios.create({ baseURL: `${PORTAL_API}/planner`, withCredentials: true });
plannerApi.interceptors.request.use((cfg) => {
    cfg.headers["X-Planner-Guest"] = guestId();
    return cfg;
});

export const safeNext = (p) => (p && p.startsWith("/portal/") && !p.startsWith("//") ? p : "/portal/dashboard");

export const track = (event, planner_type = "", establishment_type = "") =>
    plannerApi.post("/event", { event, planner_type, establishment_type }).catch(() => {});

export const FREQUENCIES = [
    ["weekly", "Weekly"], ["fortnightly", "Fortnightly"], ["monthly", "Monthly"],
    ["quarterly", "Quarterly"], ["one-time", "One-time"],
];
export const UOMS = ["", "kg", "g", "L", "ml", "pcs", "pack", "box", "dozen", "roll", "bag"];

export const planHome = (type) => `/portal/essentials-planner/${type.toLowerCase()}/start`;

export default plannerApi;
